/** Tiny typed event bus. */
import type { GameEvents } from './services';

type Handler<T> = (payload: T) => void;

export class EventBus {
  private handlers = new Map<string, Set<Handler<any>>>();
  /** Ring buffer of recent events (QA/debug). */
  readonly log: Array<{ t: number; name: string; payload: unknown }> = [];

  on<K extends keyof GameEvents>(name: K, fn: Handler<GameEvents[K]>): () => void {
    const key = name as string;
    if (!this.handlers.has(key)) this.handlers.set(key, new Set());
    this.handlers.get(key)!.add(fn);
    return () => this.handlers.get(key)?.delete(fn);
  }

  emit<K extends keyof GameEvents>(name: K, payload: GameEvents[K]): void {
    this.log.push({ t: performance.now(), name: name as string, payload });
    if (this.log.length > 300) this.log.shift();
    for (const fn of this.handlers.get(name as string) ?? []) {
      try {
        fn(payload);
      } catch (err) {
        console.error(`[events] handler for ${String(name)} failed`, err);
      }
    }
  }
}
